import React, { ElementType } from 'react';
import parse from 'html-react-parser';
import Image from '../image/Image';
import { ISpotCard } from '../../interfaces/generic';
import { removeExtraSpaces } from '../../scripts/helpers';
type SpotIconBgVariants = 'light' | 'white';

type SpotProps = {
  className?: string;
  content: ISpotCard[];
  headingTag?: ElementType<any>;
  variant?: SpotIconBgVariants;
};

class SpotIconCardsGroup extends React.Component<SpotProps> {
  constructor(props: SpotProps) {
    super(props);
  }

  render() {
    const returnVariant = () => {
      let variant = 'bg-white';
      if (this.props.hasOwnProperty('variant')) {
        variant = this.props.variant === 'light' ? 'bg-light' : variant;
      }
      return variant;
    };
    const returnColSize = () => {
      const remainder = content.length % 3;
      return remainder === 0 ? 'col-lg-4' : 'col-lg-6';
    };

    const content = this.props.content;
    const CustomHeadingTag = this.props.headingTag || 'h3'; //start with capital

    return (
      <div className="row gy-4">
        {content.map((element: ISpotCard, index: number) => (
          <div
            key={index}
            className={removeExtraSpaces(`${returnColSize()} ${this.props.className || ''}`)}>
            <div
              className={`card ${returnVariant()} d-flex ${
                element.subcopy ? '' : 'align-items-center'
              }`}>
              <Image
                className="spot-icon-md"
                src={element.image.src}
                lazyLoading
                width={element.image.width || '48'}
                height={element.image.height || '48'}
                alt={element.image.alt || ''}
              />
              <div className="ms-3">
                <CustomHeadingTag className={`h5 text-secondary ${element.subcopy ? '' : 'mb-0'}`}>
                  {parse(element.heading)}
                </CustomHeadingTag>
                {element.subcopy && <p className="mb-0 text-gray">{parse(element.subcopy)}</p>}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default SpotIconCardsGroup;
